import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import ColorPalette from './ColorPalette';
import { saveCanvasState } from '../../Actions/Rutab/HistoryActions';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash-es';
const PathMenuContent = memo(({ canvas, activeObject }) => {
    const [colorPaletteOpen, setColorPaletteOpen] = useState(false);
    const dispatch = useDispatch();
    const debouncedColorChange = debounce(() => {
        dispatch(saveCanvasState(canvas));
    }, 300);
    const changeTextColor = (color) => {
        activeObject.set({
            fill: color,
        });
        canvas.renderAll();
        debouncedColorChange();
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                    position: 'relative',
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer',
                    borderRadius: '50%',
                    border: 'none',
                    background: activeObject.fill,
                }, onClick: () => setColorPaletteOpen(!colorPaletteOpen) }), colorPaletteOpen && (_jsx("div", { className: "selected-object-color-selector", style: {
                    top: `${-95}px`,
                    left: `${0}px`,
                    width: '320px',
                }, children: _jsx(ColorPalette, { selectedColor: activeObject.fill, onColorChange: changeTextColor }) }))] }));
});
export default PathMenuContent;
